<template>
  <div>
    <el-dialog
      :close-on-click-modal="false"
      title="选择图库图片"
      :visible.sync="visible"
      width="1000px"
      class="gallery_dialog"
      :before-close="handleClose"
    >
    <div class="content">
      <div class="menu">
        <div
          v-show="partMode == '1'"
          @click="handleSelectMaterial(0)"
          :class="{ 'menu-item-select': currentMaterial === 0 }"
          class="menu-item"
        >
          印花图库
        </div>
        <div
          v-show="partMode == '1'"
          @click="handleSelectMaterial(1)"
          :class="{ 'menu-item-select': currentMaterial === 1 }"
          class="menu-item"
        >
          收费图库
        </div>
        <div
          v-show="partMode == '1'"
          @click="handleSelectMaterial(2)"
          :class="{ 'menu-item-select': currentMaterial === 2 }"
          class="menu-item"
        >
          共享图库
        </div>
        <div
          v-show="partMode == '2'"
          @click="handleSelectMaterial(3)"
          :class="{ 'menu-item-select': currentMaterial === 3 }"
          class="menu-item"
        >
          刺绣图片
        </div>
        <div
          @click="handleSelectMaterial(4)"
          :class="{ 'menu-item-select': currentMaterial === 4 }"
          class="menu-item"
        >
          采集图库
        </div>
      </div>
      <ImageList
        ref="imageMe"
        @add="handleAddImage"
        mapSource="02"
        routeName="imageMe"
        v-if="currentMaterial === 0"
      ></ImageList>
      <ImageList
        ref="imageCommon"
        @add="handleAddImage"
        mapSource="01"
        routeName="imageCommon"
        v-if="currentMaterial === 1"
      ></ImageList>
      <ImageList
        ref="imageShare"
        @add="handleAddImage"
        mapSource="01"
        routeName="imageShare"
        v-if="currentMaterial === 2"
      ></ImageList>
      <ImageList
        ref="imageOrder"
        @add="handleAddImage"
        mapSource="01"
        routeName="imageOrder"
        v-if="currentMaterial === 3"
      ></ImageList>
      <div
        ref="imageColl"
        class="image_coll"
        v-if="currentMaterial === 4"
      >
      <el-input
        class="search_input"
        placeholder="搜索图片 标题"
        prefix-icon="el-icon-search"
        v-model="queryParams.proName"
        size="small"
        @change="getCollData(1)">
      </el-input>
      <div class="per_img">
        <img v-for="item in collPicList" :src="item.picUrl" alt="采集图" @click="handleAddImage(item)">
      </div>
      <div class="pagination">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="queryParams.pageNum"
          layout="total, prev, next, jumper"
          :total="total"
          :page-size="queryParams.pageSize"
        >
        </el-pagination>
      </div>
    </div>
    </div>
    </el-dialog>
    <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">返回</el-button>
    </span> -->
  </div>
</template>

<script>
import ImageList from "@/views/customProduct/online/components/ImageList.vue"
import { queryPicList } from "@/api/product/coll"

export default {
  name: "GalleryDialog",
  data() {
    return {
      partMode: "1",
      currentUploadImage: 0,
      currentMaterial: 0,
      queryParams: {
        pageNum: 1,
        pageSize: 30,
        proName: '',
      },
      collPicList: [],
      total: 0,
    };
  },
  props: {
    visible: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  components: {
    ImageList,
  },
  methods: {
    handleSelectMaterial(index) {
      this.currentMaterial = index
      this.$nextTick(() => {
        if (index == 0) {
          this.$refs["imageMe"].getData()
        }
        if (index == 1) {
          this.$refs["imageCommon"].getData()
        }
        if (index == 2) {
          this.$refs["imageShare"].getData()
        }
        if (index == 3) {
          this.$refs["imageOrder"].getData()
        }
        if (index == 4) {
          this.getCollData()
        }
      });
    },
    async handleAddImage(data) {
        this.$emit("onClose",data)
    },
    getCollData(value) {
      if (value === 1) {
        // 搜索重置页码
        this.queryParams.pageNum = 1
      }
      this.startLoading()
      queryPicList(this.queryParams).then((res)=> {
        if (res.code == 200) {
          this.total = res.total
          this.collPicList = res.rows
        }
        this.endLoading()
      }).catch((err) => {
        this.endLoading()
        console.log(err)
      })
    },
    handleCurrentChange(pageNum) {
      this.queryParams.pageNum = pageNum
      this.getCollData()
    },
    handleClose() {
      this.$emit("onClose")
    },
  },
};
</script>

<style scoped lang="scss">
.gallery_dialog {
    .content {
        .menu {
          overflow: hidden;
          margin: 0 0 1rem 0;
          .menu-item {
            float: left;
            margin: 0 1.3125rem 0 0;
            padding: 0 0 0.25rem 0;
            width: 3.5rem;
            text-align: center;
            box-sizing: border-box;
            cursor: pointer;
          }
          .menu-item-select {
            border-bottom: 0.125rem solid #4934b2;
          }
        }
        // 列表调整样式
        &::v-deep .classify {
            padding: 16px 8px 0 0;
        }
        &::v-deep .result {
          flex: 1;
          overflow: hidden;
          position: relative;
          padding-bottom: 20px;

          .result-content {
            height: calc(100vh - 520px);
            overflow: auto;
            padding: 0 0 8px 0;
            margin: 8px 0 23px 0;
          }
          .active {
            border: 1px solid #4934b2 !important;
          }

          .item {
            width: 95px;
            height: 95px;
            float: left;
            margin-top: 9px;
            margin-left: 8px;
            position: relative;
            border: solid 1px #e5e5e5;
            box-sizing: border-box;
            border-radius: 5px;

            img {
              width: 100%;
              height: 100%;
              background-size: cover;
              background-repeat: no-repeat;
              background-position: center;
              border-radius: 5px;
            }
          }
          .item:hover {
            // box-shadow: rgb(0 0 0 / 5%) 2px 6px 10px 5px;
            border: 1px solid #4934b2 !important;
          }
          .result-content :nth-child(9n + 1) {
            margin-left: 0px;
          }
        }
        &::v-deep .pagination {
          width: 100%;
          height: 44px;
          position: absolute;
          left: 0px;
          right: 0;
          bottom: 0;
          background: #fff;
          display: flex;
          justify-content: center;
          align-items: center;
          .el-pagination__total {
            margin-right: 0px;
          }
          .btn-prev {
            padding-right: 0px;
          }
          .btn-next {
            padding-left: 0px;
          }
          .el-pagination__jump {
            margin-left: 8px;
          }
          .el-pagination .el-select .el-input {
            width: 86px;
          }
        }

        .image_coll {
          display: flex;
          justify-content: flex-start;
          align-content: flex-start;
          flex-wrap: wrap;
          // height: calc(100vh - 520px);
          // overflow: auto;
          padding: 0 0 8px 0;
          margin: 8px 0 28px 0;
          .search_input {
            margin-bottom: 16px;
          }
          .per_img {

            img {
              width: 95px;
              height: 95px;
              margin-top: 9px;
              margin-right: 13px;
              border-radius: 5px;
              cursor: pointer;
              &:nth-child(9n) {
                margin-right: 0px;
              }
            }
          }
          .pagination {
            height: 60px;
          }
        }
    }
}
</style>
